import { IconButton, Typography } from '@mui/material';
import React, { useContext } from 'react'
import { MainFormContext  } from '../MainForm';

import MenuIcon from '@mui/icons-material/Menu';

type Props = {
  label?: React.ReactNode
}

const AppMenuButton = ({ label, ...props }: Props) => {

  const mMainForm_Context = useContext(MainFormContext );

  return (
    <>
      <IconButton edge="start" color="inherit" aria-label="menu" sx={{}}
        onClick={() => { mMainForm_Context?.set_IsAppMenuOpen(true); }}
      >
        <MenuIcon />
      </IconButton>
      {label !== null ? render_AppTitle(label) : undefined}
    </>
  )

  function render_AppTitle(label: React.ReactNode) {
    return <>
      <Typography variant="subtitle2" component="div" noWrap
        sx={{ display: { xs: 'none', sm: 'block', cursor: 'pointer' } }}
        onClick={() => { mMainForm_Context?.set_IsAppMenuOpen(true); }}
      >
        {label}
      </Typography>
    </>
  }

}

export default AppMenuButton